import { renewalActions } from "../actions";
import constants from "../../data/renewal.json";

const initialState = {
  lovs: {
    ...constants.lovs,
    transmission: [
      {
        transmissionCode: "1",
        transmissionDescription: "automatic",
      },
      {
        transmissionCode: "2",
        transmissionDescription: "manual",
      },
    ],
    genders: [
      { label: "male", value: "M" },
      { label: "female", value: "F" },
    ],
    agencyRepair: [
      { label: "workshop", value: "N" },
      { label: "agency", value: "Y" },
    ],
    peps: [
      { label: "no", value: "N" },
      { label: "yes", value: "Y" },
      { label: "mm-pep-yes-family-label", value: "F" },
    ],
    yesNo: [
      { label: "no", value: "N" },
      { label: "yes", value: "Y" },
    ],
    mailingAddress: [
      { label: "uhm", value: "WA" },
      { label: "pob", value: "PO" },
    ],
  },
  loading: false,
  choosenProposal: {},
  chosenProductCode: "PRMotorImtiazeSP",
  isLoggedIn: false,
  updateDate: new Date().toISOString(),
  policyData: {},
  quotationDetails: {},
  proposalDetails: {},
  defaultValuesDetails: {},
  renewalListDetails: {},
  renewalCarColor: {},
  callingApi: false,
  otpIndex: 0,
  yob: "",
  uid: false,
  saveClicked: true,
  driverRegistered: {
    mobile: null,
    isDriverRegistered: false,
    isDriverSelected: false,
  },
  authToken: null,
  requestId: null,
  jwt: null,
};

const renewalReducers = (state = initialState, action) => {
  switch (action.type) {
    case renewalActions.actions.AUTHENTICATE:
      return {
        ...state,
        ...action.payload,
      };
    case renewalActions.actions.UPDATE_POLICY:
      return {
        ...state,
        policyData: { ...action.payload },
      };
    case renewalActions.actions.UPDDATE_QOUTATION:
      return {
        ...state,
        quotationDetails: { ...action.payload },
        isLoggedIn: true,
      };
    case renewalActions.actions.UPDATE_USER_LOGGED_IN:
      return {
        ...state,
        isLoggedIn: action.payload,
      };
    case renewalActions.actions.UPDATE_PROPOSAL:
      const proposals = action.payload.proposals.proposalsArray;
      let newProposalDetails = [];
      if (action.payload.productFamilyCode !== "ALL") {
        const oldProposals =
          state.proposalDetails.proposals.proposalsArray.filter(
            (p) => p.productSubCode !== proposals.productSubCode
          );

        state.proposalDetails.proposals.proposalsArray = [
          ...oldProposals,
          proposals,
        ];

        newProposalDetails = { ...state.proposalDetails };
      } else {
        newProposalDetails = { ...action.payload };
      }
      return { ...state, proposalDetails: newProposalDetails };
    case renewalActions.actions.UPDATE_DEFAULT_VALUES:
      return {
        ...state,
        defaultValuesDetails: { ...action.payload },
      };
    case renewalActions.actions.UPDATE_CURRENT_PLAN:
      return {
        ...state,
        defaultValuesDetails: { ...action.payload },
      };
    case renewalActions.actions.UPDATE_RENEWAL_LIST:
      return {
        ...state,
        renewalListDetails: { ...action.payload },
      };
    case renewalActions.actions.UPDATE_CHOOSE_PRODUCT_CODE:
      return {
        ...state,
        chosenProductCode: action.payload,
      };
    case renewalActions.actions.UPDATE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case renewalActions.actions.UPDATE_SAVE:
      return {
        ...state,
        saveClicked: action.payload,
      };

    case renewalActions.actions.UPDATE_CALLING_API:
      return {
        ...state,
        callingApi: action.payload,
      };

    case renewalActions.actions.UPDATE_OTP_INDEX:
      return {
        ...state,
        callingApi: action.payload,
      };
    case renewalActions.actions.UPDATE_YOB:
      return {
        ...state,
        yob: action.payload,
      };
    case renewalActions.actions.UPDATE_COLOR:
      return {
        ...state,
        renewalCarColor: action.payload,
      };
    case renewalActions.actions.UPDATE_UID:
      return {
        ...state,
        uid: action.payload,
      };
    case renewalActions.actions.CHANGE_DRIVER_SELECTED:
      return {
        ...state,
        driverRegistered: {
          ...state.driverRegistered,
          isDriverSelected: action.payload,
        },
      };
    default:
      return state;
  }
};

export default renewalReducers;
